export default function (values: Array<number>): number {
  let total = 0;
  for (const value of values) {
    total += value;
  }
  return total;
}
